module.exports = ".row:nth-child(odd){\r\nbackground:#f2f2f2;\r\n}\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/proposal-report/proposal-form/proposal-form.component.css
// module id = ./src/app/landprocurement/proposal-report/proposal-form/proposal-form.component.css
// module chunks = main